module.exports = __webpack_public_path__ + "/images/cover-cta-caja-lila.c76e198.jpg";